import { ExternalLink } from 'lucide-react';
import { EVENT_TYPE_LABELS } from '../../types/cashCockpit';
import { formatEur } from './charts/IbcsTooltip';
import type { PlannedCashEvent } from '../../types/cashCockpit';

interface Props {
    data: PlannedCashEvent[];
}

export default function PlannedEventsReadOnlyTab({ data }: Props) {
    return (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                <h3 className="text-sm font-semibold text-gray-900">Planned Cash Events (next 13 weeks)</h3>
                <a
                    href="/bank-balance"
                    className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
                >
                    Edit on Bank Balance page <ExternalLink className="w-3.5 h-3.5" />
                </a>
            </div>
            <table className="w-full text-xs">
                <thead className="bg-gray-50 text-gray-600">
                    <tr>
                        <th className="px-3 py-2 text-left">Date</th>
                        <th className="px-3 py-2 text-left">Entity</th>
                        <th className="px-3 py-2 text-left">Type</th>
                        <th className="px-3 py-2 text-right">Amount FCY</th>
                        <th className="px-3 py-2 text-right">Amount EUR</th>
                        <th className="px-3 py-2 text-left">Confidence</th>
                        <th className="px-3 py-2 text-left">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 && (
                        <tr><td colSpan={7} className="text-center py-6 text-gray-500">No planned events in the forecast window.</td></tr>
                    )}
                    {data.map(ev => (
                        <tr key={ev.Id} className="border-t border-gray-100">
                            <td className="px-3 py-1.5">{new Date(ev.EventDate).toLocaleDateString('de-CH')}</td>
                            <td className="px-3 py-1.5 font-semibold uppercase">{ev.CompanyCode}</td>
                            <td className="px-3 py-1.5">{EVENT_TYPE_LABELS[ev.EventType]}</td>
                            <td className={`px-3 py-1.5 text-right font-mono tabular-nums ${ev.AmountFCY < 0 ? 'text-[#D7191C]' : 'text-[#2C7BB6]'}`}>
                                {ev.AmountFCY.toLocaleString('de-CH')} {ev.CurrencyCode}
                            </td>
                            <td className="px-3 py-1.5 text-right font-mono tabular-nums">{formatEur(ev.AmountFCY)}</td>
                            <td className="px-3 py-1.5">
                                <span className={`text-[10px] px-1.5 py-0.5 rounded ${
                                    ev.Confidence === 'High' ? 'bg-green-100 text-green-700'
                                    : ev.Confidence === 'Medium' ? 'bg-amber-100 text-amber-700'
                                    : 'bg-gray-100 text-gray-700'
                                }`}>{ev.Confidence}</span>
                            </td>
                            <td className="px-3 py-1.5 text-gray-600">{ev.Description || '—'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
